import { HomePage } from '#src/App/HomePage.tsx';

export default HomePage;
